/**
 * 单店营收监控 - 组件默认显示顺序
 * 用于 wrapLayout 布局，支持拖拽排序时作为默认顺序
 *
 * 用户调整后的顺序持久化在 localStorage（见下方 key）；
 * 无保存值或解析失败时使用本默认顺序，并写入本地；版本升级若默认列表新增 id，会与已保存顺序合并补全。
 */
export const STORE_REVENUE_MONITOR_COMPONENT_ORDER_STORAGE_KEY =
  "store-revenue-monitor:component-order";

/**
 * 与 DEFAULT 合并：保留用户顺序、去重、剔除非法 id，并将默认里新增的组件 id 追加到末尾。
 */
export function mergeComponentOrderWithDefaults(
  order: string[] | undefined,
  defaultList: readonly string[],
): string[] {
  if (!Array.isArray(defaultList)) {
    return [];
  }
  const allowed = new Set<string>(defaultList);
  const seen = new Set<string>();
  const result: string[] = [];
  if (Array.isArray(order) && order.length > 0) {
    for (const id of order) {
      if (typeof id !== "string" || !allowed.has(id) || seen.has(id)) continue;
      seen.add(id);
      result.push(id);
    }
  }
  for (const id of defaultList) {
    if (!seen.has(id)) {
      result.push(id);
    }
  }
  /** 门店信息概览固定为首卡（与默认顺序一致；其余 id 相对顺序不变） */
  const lead = "store-overview";
  const leadIdx = result.indexOf(lead);
  if (leadIdx > 0) {
    result.splice(leadIdx, 1);
    result.unshift(lead);
  }
  return result;
}

export const DEFAULT_COMPONENT_ORDER = [
  "store-overview",
  "expected-arrival-today",
  "expected-departure-today",
  "in-house-today",
  "order-traffic",
  "room-status",
  "room-status-recently",
  "room-health",
  "hourly-price-by-room",
  "channel-price",
  "revpar",
  "customer-source",
  "discount-analysis",
  "occupancy-analysis",
  "operation-efficiency",
  "channel-info",
  "channel-analysis",
] as const;

export type ComponentTypeId = (typeof DEFAULT_COMPONENT_ORDER)[number];
